import { createSvgIcon } from '@mui/material/utils'

const WarningPlate = createSvgIcon(
  <>
    <path
      d="M0.5 61.41H89.52C89.52 64.08 87.35 66.25 84.68 66.25H5.34C2.67 66.25 0.5 64.08 0.5 61.41Z"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M22.41 17.5C24.62 7.77 33.32 0.5 43.72 0.5C54.74 0.5 63.85 8.65 65.35 19.25"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M25.01 38.37C23.16 39.41 21.03 40 18.76 40C11.71 40 6 34.29 6 27.24C6 20.19 11.71 14.48 18.76 14.48C20.18 14.48 21.55 14.71 22.83 15.14"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path
      d="M63.95 39C65.9 40.1 68.15 40.72 70.55 40.72C77.99 40.72 84.0199 34.69 84.0199 27.25C84.0199 19.81 77.99 13.78 70.55 13.78C68.39 13.78 66.3399 14.29 64.5299 15.19"
      stroke="#204ECF"
      strokeLinejoin="round"
    />
    <path d="M20.72 39.83V61.41H66.74V40.27" stroke="#204ECF" strokeLinejoin="round" />
    <path d="M44.38 21.73L30.54 45.7H58.22L44.38 21.73Z" stroke="#204ECF" strokeMiterlimit="10" />
    <path
      d="M44.306 36.44L44.522 30.896H42.986L43.214 36.44H44.306ZM43.766 39.02C44.222 39.02 44.594 38.636 44.594 38.18C44.594 37.736 44.222 37.352 43.766 37.352C43.31 37.352 42.926 37.736 42.926 38.18C42.926 38.636 43.31 39.02 43.766 39.02Z"
      fill="#204ECF"
    />
  </>,
  'WarningPlate'
)

export default WarningPlate
